import { useContext, useEffect } from "react";
import { Button } from "@/components/Button/Button";
import { FeedbackSurveyButton } from "@/components/Feedback/FeedbackSurveyButton";
import { PageFooter } from "@/components/PageFooter/PageFooter";
import { PageHelmet } from "@/components/PageHelmet/PageHelmet";
import { AppText } from "@/components/Text/AppText";
import { EditorContext } from "@/context/EditorContext";
import { useAppDispatch } from "@/hooks/types";
import { useInvalidateResumesCache } from "@/hooks/useAppData";
import { JobBoardTable } from "@/pages/Jobs/JobBoardTable";
import { resetResumeBuilderState } from "@/routes/utils/resetResumeBuilderState";
import { EditorContextType } from "@/types/editor";
import { AppRoutes } from "@/types/routes";

export const JobsPage = () => {
    const { destroyEditors } = useContext(EditorContext) as EditorContextType;
    const dispatch = useAppDispatch();
    const invalidateResumes = useInvalidateResumesCache();

    useEffect(() => {
        // Ensure we kill all editors and reset the builder when navigating between resumes
        destroyEditors();
        resetResumeBuilderState(dispatch);
    }, [destroyEditors, dispatch]);

    useEffect(() => {
        invalidateResumes();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <PageHelmet title="Job Board" />
            <main className="mt-6 min-h-[calc(100vh-300px)] px-8 pb-16 lg:mt-16">
                <div className="mx-0 mb-6 flex w-full max-w-6xl flex-col justify-between px-0 lg:mx-auto lg:mb-12 lg:flex-row lg:px-20 xl:mb-16 xl:w-2/3 xl:px-0">
                    <div className="flex items-center gap-3">
                        <AppText
                            variant="headings"
                            className="text-neutral-900"
                        >
                            Job Board
                        </AppText>
                        <div className="flex items-center gap-2 rounded-lg bg-primary-700 px-2 py-1 text-neutral-50">
                            <AppText variant="footnote">BETA</AppText>
                        </div>
                    </div>
                    <div className="mt-0 flex flex-col-reverse items-center gap-3 md:mt-6 lg:my-0 lg:flex-row">
                        <Button
                            variant="outline"
                            to={`/${AppRoutes.YourJobs}`}
                        >
                            View Saved Jobs
                        </Button>
                    </div>
                </div>
                <div className="mx-0 mb-6 flex w-full max-w-6xl flex-col justify-between gap-4 px-0 lg:mx-auto lg:mb-12 lg:px-20 xl:mb-16 xl:px-0">
                    <JobBoardTable />
                </div>
                <FeedbackSurveyButton />
            </main>
            <PageFooter />
        </>
    );
};
